<div class="calls-page">
  <div class="page-header">
    <div>
      <h2>Calls</h2>
      <p>Start single or conference calls with voice or video options.</p>
    </div>
  </div>

  <section class="incoming-call" *ngIf="incomingCall">
    <div>
      <span>Incoming {{ incomingCall.callType }}</span>
      <h3>{{ incomingCall.title }}</h3>
      <p>{{ incomingCall.startedByName || 'A user' }} is calling you.</p>
    </div>
    <div class="incoming-actions">
      <button mat-flat-button color="primary" (click)="acceptIncomingCall()">
        <mat-icon>call</mat-icon>
        Accept
      </button>
      <button mat-flat-button color="warn" (click)="rejectIncomingCall()">
        <mat-icon>call_end</mat-icon>
        Reject
      </button>
    </div>
  </section>

  <div class="calls-grid">
    <section class="call-setup">
      <h3>New Call</h3>

      <div class="control-row">
        <button mat-stroked-button [color]="callScope === 'single' ? 'primary' : undefined" (click)="setScope('single')">
          Single
        </button>
        <button mat-stroked-button [color]="callScope === 'conference' ? 'primary' : undefined" (click)="setScope('conference')">
          Conference
        </button>
      </div>

      <div class="control-row">
        <button mat-stroked-button [color]="callMode === 'voice' ? 'primary' : undefined" (click)="callMode = 'voice'">
          <mat-icon>call</mat-icon>
          Voice
        </button>
        <button mat-stroked-button [color]="callMode === 'video' ? 'primary' : undefined" (click)="callMode = 'video'">
          <mat-icon>videocam</mat-icon>
          Video
        </button>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>{{ callScope === 'conference' ? 'Participants' : 'Participant' }}</mat-label>
        <mat-select multiple [(value)]="selectedParticipants" panelClass="chat-user-select-panel">
          <mat-option>
            <input
              matInput
              class="select-search-input"
              [(ngModel)]="userSearchTerm"
              placeholder="Search users"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
          </mat-option>
          <mat-option *ngFor="let user of filteredUsers" [value]="user" [disabled]="callScope === 'single' && selectedParticipants.length === 1 && selectedParticipants[0] !== user">
            {{ user.fullName || user.email }}
            <span class="option-meta">{{ user.department || user.position || user.email || 'Staff user' }}</span>
          </mat-option>
          <mat-option *ngIf="!filteredUsers.length" disabled>
            {{ loadingUsers ? 'Loading users...' : 'No matching users found.' }}
          </mat-option>
        </mat-select>
        <mat-hint>{{ callScope === 'single' ? 'Choose exactly one user' : 'Choose at least two users' }}</mat-hint>
      </mat-form-field>

      <button mat-flat-button color="primary" [disabled]="!canStartCall" (click)="startCall()">Start Call</button>
    </section>

    <section class="call-stage" [class.active]="activeCall">
      <ng-container *ngIf="activeCall; else idleState">
        <div class="call-stage-head">
          <div>
            <h3>{{ activeCall.title }}</h3>
            <p>{{ participantNames(activeCall) }}</p>
          </div>
          <span>{{ activeCall.callScope }} {{ activeCall.callType }}</span>
        </div>

        <div class="video-grid">
          <div class="video-tile local">
            <video #localVideo autoplay muted playsinline></video>
            <div class="tile-label">You</div>
            <mat-icon *ngIf="activeCall.callType !== 'Video' || cameraOff">account_circle</mat-icon>
          </div>

          <div class="video-tile" *ngFor="let remote of remoteStreams">
            <video
              autoplay
              playsinline
              #remoteVideo
              (loadedmetadata)="remoteVideo.play()"
            ></video>
            <div class="tile-label">{{ remote.displayName }}</div>
          </div>

          <div class="video-tile waiting" *ngIf="!remoteStreams.length">
            <mat-icon>person_add</mat-icon>
            <p>Waiting for participants to join...</p>
          </div>
        </div>

        <div class="call-actions">
          <button mat-stroked-button (click)="toggleMic()">
            <mat-icon>{{ micMuted ? 'mic_off' : 'mic' }}</mat-icon>
            {{ micMuted ? 'Unmute' : 'Mute' }}
          </button>
          <button mat-stroked-button *ngIf="activeCall.callType === 'Video'" (click)="toggleCamera()">
            <mat-icon>{{ cameraOff ? 'videocam' : 'videocam_off' }}</mat-icon>
            {{ cameraOff ? 'Camera On' : 'Camera Off' }}
          </button>
          <button mat-flat-button color="warn" (click)="endCall()">
            <mat-icon>call_end</mat-icon>
            End
          </button>
        </div>
      </ng-container>
      <ng-template #idleState>
        <mat-icon>perm_phone_msg</mat-icon>
        <h3>Ready to connect</h3>
        <p>Choose the call type, add participants, and start when ready.</p>
      </ng-template>
    </section>

    <section class="recent-calls">
      <h3>Recent Calls</h3>
      <div class="recent-row" *ngFor="let call of recentCalls">
        <div>
          <strong>{{ call.title }}</strong>
          <p>{{ call.callScope }} {{ call.callType }} • {{ formatWhen(call.startedAt) }}</p>
        </div>
        <span [class.missed]="call.status === 'Missed'">{{ call.status }}</span>
      </div>
      <div class="empty-calls" *ngIf="!recentCalls.length">{{ loadingCalls ? 'Loading calls...' : 'No calls yet.' }}</div>
    </section>
  </div>
</div>
